/* eslint-disable react/prop-types */
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editActuacion, selectExpediente, STATUS } from '../expedienteSlice';
import DocumentoEditable from '../documento/DocumentoEditable';
import SubirDocumento from '../documento/SubirDocumento';
import DocLink from '../documento/DocLink';

export default function Actuacion ({index, editable}) {
    const dispatch = useDispatch();
    const [changed, setChanged] = useState(false);
    const expediente = useSelector(selectExpediente);
    const actuacion = useMemo(() => expediente.actuaciones[index], [expediente, index]);
    const prevActuacionRef = useRef(null);

    useEffect(() => {
        // Initialize the ref on first render
        if (prevActuacionRef.current === null) {
            prevActuacionRef.current = actuacion;
            return;
        }
        
        // Check if this specific actuacion actually changed
        if (JSON.stringify(prevActuacionRef.current) !== JSON.stringify(actuacion)) {
            setChanged(true);
        }
        
        prevActuacionRef.current = actuacion;
    }, [actuacion]);

    useEffect(() => {
        if (expediente.status === STATUS.SAVED) {
            setChanged(false);
            prevActuacionRef.current = actuacion;
        }
    }, [expediente.status, actuacion]);

    function onChangeHandler({target}) {
        const name = target.name;
        const value = target.value;
        dispatch(editActuacion({
            index,
            name,
            value
        }));
    }

    return (
        <div key={`${index}`}  className='actuacion'>
            <p>{`${index+1}.`}</p>
            <div className="actuacion-data">
                <label htmlFor={`fecha_actuacion-${index}`}>Fecha:</label>
                { editable
                    ? <input type="date" id={`fecha_actuacion-${index}`} name="fecha_actuacion" 
                        value={actuacion.fecha_actuacion || ''}
                        onChange={onChangeHandler}/>
                    : <input type="date" id={`fecha_actuacion-${index}`} name="fecha_actuacion"
                        value={actuacion.fecha_actuacion}/>
                }
                <label htmlFor={`descripcion_actuacion-${index}`}>Descripción de la actuación:</label>
                { editable
                    ? <textarea id={`descripcion_actuacion-${index}`} name="descripcion_actuacion"
                        onChange={onChangeHandler}>
                        {actuacion.descripcion_actuacion || ''}
                    </textarea>
                    : <div className='textarea-content' id={`descripcion_actuacion-${index}`}>
                        <pre>{actuacion.descripcion_actuacion || ''}</pre>
                    </div>
                }
                <label htmlFor="documento_actuacion">Documentos adjuntos:</label>
                { editable 
                    ? <div>
                        { actuacion.documento_actuacion && actuacion.documento_actuacion.length > 0 && (
                            actuacion.documento_actuacion.map((doc, i) => (
                                <DocumentoEditable key={i} actuacionIndex={index} documentIndex={i}/>
                            ))
                        )}
                    </div>
                    : actuacion.documento_actuacion && actuacion.documento_actuacion.length > 0
                        ? actuacion.documento_actuacion.map((doc, i) => <DocLink key={i} documento={doc} />)
                        : '-'
                }
                { editable &&
                    <SubirDocumento actuacionIndex={index}/>
                }
                <div className='field'>
                    <label htmlFor={`responsable_actuacion-${index}`}>Responsable:</label>
                    { editable
                        ? <input type="text" id={`responsable_actuacion-${index}`} name="responsable_actuacion"
                            value={actuacion.responsable_actuacion || ''}
                            onChange={onChangeHandler}/>
                        : <input type="text" id={`responsable_actuacion-${index}`} name="responsable_actuacion"
                            value={actuacion.responsable_actuacion}/>
                    }
                </div>
                { changed && expediente.status !== STATUS.SAVED &&
                    <div className='reminder'>* Recuerda guardar el expediente para registrar los cambios.</div>
                }
            </div>
        </div>
    );

}